import { Theme } from '@emotion/react';
import { CSSProperties } from 'react';

export type CodeLanguage = 'python' | 'javascript' | 'sql' | 'json' | 'bash' | 'typescript';

export const customSyntaxTheme: (theme: Theme) => Record<string, CSSProperties> = (theme) => {
  return {
    'pre[class*="language-"]': {
      color: theme.v1.colors.text.text,
      fontFamily: `'${theme.font.familyCode}', monospace`,
      overflowX: 'scroll',
    },
    comment: { color: theme.v1.colors.text.subduedText, fontStyle: 'italic' },
    keyword: { color: theme.v1.colors.viz['3-violet'].text, fontWeight: 'bold' },
    string: { color: theme.v1.colors.viz['2-rose'].text },
    function: { color: theme.v1.colors.text.text },
    variable: { color: theme.v1.colors.viz['7-blue'].text },
    'class-name': { color: theme.v1.colors.viz['9-purple'].text },
    operator: { color: theme.v1.colors.viz['6-orange'].text },
    deleted: { color: theme.v1.colors.text.dangerText },
    inserted: { color: theme.v1.colors.text.successText },
    unchanged: { color: theme.v1.colors.text.subduedText },
    number: { color: theme.v1.colors.viz['10-green'].text },
  };
};
